import { RootScopeEvents } from './../../common/services/root-scope-types';
import angular from 'angular';
import template from './user-media-status.html';
import './user-media-status.scss';
import common from './common/user-media-status.common';
import bowser from 'bowser';
import * as devices from '../../modules/devices';
import * as localMedia from '../../modules/local-media';
import { OTPublisherErrors } from '../../providers/video/tokbox/tokbox-video-provider.class';
import { PARTICIPANTS_MAX_COUNT_FOR_MEDIUM_FRAMES, StreamType, } from '../../modules/call/constants';
import { ConnectionStateCameraStatus } from '../../providers/video/common/interfaces/person-connection';
import { PnCameraStatus, PnEvents } from '../../realtime';
import { VideoProviderEvents } from '../../providers/video';
export class UserMediaStatusController {
    // @TODO: this component is instantiated twice for patients, that leads to duplication of some actions,
    //   like sending image twice, etc. Fix it!
    constructor($rootScope, $timeout, VideoProviderFactory, notificationFactory, 
    // private Devices,
    pn, Browser, notifications, publisherManager, globalUi, ModalFactory, enableCameraErrorHandler, $ngRedux) {
        this.$rootScope = $rootScope;
        this.$timeout = $timeout;
        this.VideoProviderFactory = VideoProviderFactory;
        this.notificationFactory = notificationFactory;
        this.pn = pn;
        this.Browser = Browser;
        this.notifications = notifications;
        this.publisherManager = publisherManager;
        this.globalUi = globalUi;
        this.ModalFactory = ModalFactory;
        this.enableCameraErrorHandler = enableCameraErrorHandler;
        this.$ngRedux = $ngRedux;
        this.isLoaded = false;
        this.userMediaAccessState = 'default';
        this.supportState = 'supported';
        this.continueWithoutCamera = false;
        this.scopeListeners = [];
        this.updateUserPicture = () => {
            if (this.pn.userPicture ||
                this.pn.isDoctor() ||
                !this.isCheckInPhotoCaptureEnabled) {
                return;
            }
            const size = { width: 165, height: 165 };
            this.publisherManager
                .getCachedCapture(size)
                .then((cache) => cache || this.publisherManager.capturePhotoWithCrop(size))
                .then((photo) => photo && this.pn.setUserPictureFromCamera(photo));
        };
        this.handleUserMediaSuccess = () => {
            const cameraStatus = this.hasCameraAccess
                ? PnCameraStatus.Success
                : PnCameraStatus.Blocked;
            this.userMediaAccessState = 'allowed';
            this.pn.setState({
                cameraStatus: cameraStatus,
                hasCameraAccess: this.hasCameraAccess,
                hasMicrophoneAccess: this.hasMicrophoneAccess,
            });
            this.VideoProviderFactory.activeProvider.updateState({
                onlyChat: false,
                cameraStatus: ConnectionStateCameraStatus.Success,
            });
            const UPDATE_USER_PICTURE_DELAY = this.Browser.isMobileSafari() ? 100 : 0; // To fix black screen images (mostly on Safari/ios)
            this.$timeout(() => this.pn.connected
                ? this.updateUserPicture()
                : this.pn.on(PnEvents.Connected, this.updateUserPicture), UPDATE_USER_PICTURE_DELAY);
            this.$rootScope.$applyAsync();
        };
        this.handleUserMediaError = () => {
            this.userMediaAccessState = 'error';
            this.VideoProviderFactory.activeProvider.updateState({
                cameraStatus: ConnectionStateCameraStatus.Error,
            });
            this.$rootScope.$applyAsync();
        };
        this.unsubscribeFromStore = this.$ngRedux.connect(this.mapStateToThis)(this);
        this.unsubscribeFromStoreUpdate = this.$ngRedux.subscribe(() => this.onStoreUpdate());
        VideoProviderFactory.decorateScope(this);
    }
    checkDevices() {
        this.$timeout(() => {
            this.userMediaAccessState = 'default';
            this.supportState = 'supported';
            if (this.hasNoDevices) {
                this.supportState = 'no-devices';
                this.pn.disableMediaAccess();
            }
            if (this.hasMediaAccess) {
                this.userMediaAccessState = 'allowed';
                this.supportState = 'supported';
            }
            this.$timeout(() => {
                if (this.cameraOff)
                    return;
                if (!this.Browser.isSupported())
                    return;
                if (this.VideoProviderFactory.activeProvider.isInCall)
                    return;
                if (!this.globalUi.ui.checkIn)
                    return this.checkWorkability();
                this.scopeListeners.push(this.$rootScope.$on(RootScopeEvents.CHECK_IN_SUCCESS, () => this.checkWorkability()));
            }, 5000);
            this.isLoaded = true;
        });
    }
    // TODO: Discuss and maybe remove completely
    checkWorkability() {
        const deviceInfo = this.allDevicesBooleanProps;
        if (deviceInfo.hasNoDevices) {
            this.notificationFactory.showCommon('error', 'no-devices', 'device-error');
        }
        else if (!deviceInfo.hasCamera) {
            this.notificationFactory.showCommon('warning', 'no-webcam', 'device-error');
        }
        else if (!deviceInfo.hasMicrophone) {
            this.notificationFactory.showCommon('warning', 'no-microphone', 'device-error');
        }
        if (!deviceInfo.hasNoDevices && deviceInfo.hasMediaAccess) {
            if (!bowser.ios && deviceInfo.hasCameraAccess) {
                this.VideoProviderFactory.activeProvider
                    .checkVideoStream()
                    .catch(() => {
                    this.notificationFactory.showCommon('warning', 'no-video-stream', 'device-error');
                });
            }
            if (!bowser.chrome && !bowser.ios && deviceInfo.hasMicrophoneAccess) {
                this.VideoProviderFactory.activeProvider
                    .checkAudioStream()
                    .catch(() => {
                    this.notificationFactory.showCommon('warning', 'microphone-silent', 'device-error');
                });
            }
        }
    }
    enableWebcam() {
        const onError = (err) => {
            this.enableCameraErrorHandler.onCommon(err);
            if (!err || !err.name)
                return;
            if (err.name === OTPublisherErrors.NotAllowedError) {
                this.$timeout(() => {
                    this.VideoProviderFactory.activeProvider.updateState({
                        cameraStatus: ConnectionStateCameraStatus.Blocked,
                    });
                    this.userMediaAccessState = 'blocked';
                });
            }
            if (err.name === 'NotFoundError') {
                this.$timeout(() => {
                    this.supportState = 'no-devices';
                });
            }
        };
        this.VideoProviderFactory.activeProvider
            .enableWebcam()
            .then(() => {
            this.supportState = 'supported';
            this.userMediaAccessState = 'allowed';
            this.ModalFactory.hideCurrentModal();
        })
            .catch(onError);
    }
    async $onInit() {
        if (!this.Browser.isSupported()) {
            this.$timeout(() => {
                this.supportState = 'unsupported';
            });
        }
        this.scopeListeners.push(this.$rootScope.$on('patient.modal.continueWithoutCameraStep', ($e, cameraEnabled) => {
            this.continueWithoutCamera = true;
            this.userMediaAccessState = cameraEnabled ? 'allowed' : 'default';
        }));
        this.scopeListeners.push(this.$rootScope.$on('patient.modal.reset', ($e, cameraEnabled) => {
            this.continueWithoutCamera = false;
            this.userMediaAccessState = cameraEnabled ? 'allowed' : 'default';
        }));
        await this.VideoProviderFactory.waitForActiveProvider();
        this.VideoProviderFactory.activeProvider.on(VideoProviderEvents.GetUserMediaSuccess, this.handleUserMediaSuccess);
        this.VideoProviderFactory.activeProvider.on(VideoProviderEvents.GetUserMediaError, this.handleUserMediaError);
        this.checkDevices();
        this.$rootScope.$on(RootScopeEvents.ACTIVE_PROVIDER.AUTO_DISABLE_MEDIA, (_e, disabled) => {
            let notification;
            let articleUrl;
            if (this.Browser.isMobile) {
                articleUrl =
                    'https://help.doxy.me/en/articles/6197200-mobile-phone-audio-video-disruptions';
            }
            else {
                articleUrl =
                    'https://help.doxy.me/en/articles/95877-allow-access-to-camera-mic';
            }
            if (disabled.audio && disabled.video) {
                notification = 'video-and-audio.auto-disabled{articleUrl}';
            }
            else if (disabled.audio) {
                notification = 'audio.auto-disabled{articleUrl}';
            }
            else if (disabled.video) {
                notification = 'video.auto-disabled{articleUrl}';
            }
            if (notification) {
                this.notificationFactory.showCommon('warning', notification, null, null, { articleUrl });
            }
        });
    }
    get streams() {
        return this.VideoProviderFactory.activeProvider.streams;
    }
    isMediumMiniature() {
        if (this.streams.length === 1) {
            return this.globalUi.ui.screenSharing;
        }
        return (this.streams.length <= PARTICIPANTS_MAX_COUNT_FOR_MEDIUM_FRAMES &&
            (this.VideoProviderFactory.activeProvider.isInGroupCall ||
                this.streams.find((s) => s.type === StreamType.Screen)));
    }
    isSmallMiniature() {
        return (this.VideoProviderFactory.activeProvider.isInGroupCall &&
            this.streams.length > PARTICIPANTS_MAX_COUNT_FOR_MEDIUM_FRAMES);
    }
    isCameraError() {
        return (this.VideoProviderFactory.activeProvider.getUserMediaLastError &&
            this.VideoProviderFactory.activeProvider.getUserMediaLastError.name !==
                OTPublisherErrors.NotAllowedError);
    }
    mapStateToThis(state) {
        return {
            accessibleCameras: devices.selectors.getAccessibleCameras(state),
            accessibleMicrophones: devices.selectors.getAccessibleMicrophones(state),
            allDevicesBooleanProps: devices.selectors.getAllDevicesBooleanProps(state),
            hasNoDevices: devices.selectors.hasNoDevices(state),
            hasMediaAccess: devices.selectors.hasMediaAccess(state),
            hasCameraAccess: devices.selectors.hasCameraAccess(state),
            hasMicrophoneAccess: devices.selectors.hasMicrophoneAccess(state),
            isFlipCameraAvailable: localMedia.selectors.selectFlipCameraAvailabilityOnMobile(state),
        };
    }
    onStoreUpdate() {
        const state = this.$ngRedux.getState();
        this.checkDevicesChange(state);
        this.checkMediaAccessChange(state);
        this.prevAppState = state;
    }
    checkMediaAccessChange(state) {
        if (!this.prevAppState)
            return;
        if (devices.selectors.hasMediaAccess(state) !==
            devices.selectors.hasMediaAccess(this.prevAppState)) {
            this.checkDevices();
        }
    }
    checkDevicesChange(state) {
        const deviceHash = devices.selectors.getDevicesHash(state);
        if (this.deviceHash !== deviceHash) {
            // not first time
            if (this.deviceHash !== undefined) {
                this.checkDevices();
            }
            this.deviceHash = deviceHash;
        }
    }
    $onDestroy() {
        this.unsubscribeFromStore();
        this.unsubscribeFromStoreUpdate();
        this.pn.off(PnEvents.Connected, this.updateUserPicture);
        this.VideoProviderFactory.activeProvider.off(VideoProviderEvents.GetUserMediaSuccess, this.handleUserMediaSuccess);
        this.VideoProviderFactory.activeProvider.off(VideoProviderEvents.GetUserMediaError, this.handleUserMediaError);
        this.scopeListeners.map((unsubscribe) => unsubscribe());
    }
}
const userMediaStatus = {
    template,
    bindings: {
        cameraOff: '<',
        patientModalOpen: '<?',
        isCheckInPhotoCaptureEnabled: '<',
    },
    controller: UserMediaStatusController,
};
export default angular
    .module('doxy.videoChat.userMediaStatus', [common])
    // user-media-status
    .component('userMediaStatus', userMediaStatus).name;
